import {
  PayLink,
  TPricingOption,
  TPricingPromotions,
  TRepresentativeInterest,
} from './PayLinkLanding.types';
import { FormalOffer } from '../../../Seller/PayLinks/utils/Paylinks.types';
import { getDurationInMonths } from '../../utils/product';

export const getPricingPromotions = ({
  pricing,
  product_pricing,
}: {
  pricing: PayLink['pricing'];
  product_pricing?: PayLink['product_pricing'];
}) => {
  if (!product_pricing) {
    return { THREE_MONTHS: pricing.promotions } as TPricingPromotions;
  }

  if (!product_pricing.TWELVE_MONTHS) {
    return {
      THREE_MONTHS: product_pricing.THREE_MONTHS.promotions,
    } as TPricingPromotions;
  }

  return {
    THREE_MONTHS: product_pricing.THREE_MONTHS.promotions,
    TWELVE_MONTHS: product_pricing.TWELVE_MONTHS.promotions,
  } as TPricingPromotions;
};

export const getRepresentativeInterest = ({
  pricing,
  product_pricing,
}: {
  pricing: PayLink['pricing'];
  product_pricing?: PayLink['product_pricing'];
}) => {
  if (!product_pricing) {
    return {
      THREE_MONTHS: pricing.representative_interest,
    } as TRepresentativeInterest;
  }

  if (!product_pricing.TWELVE_MONTHS) {
    return {
      THREE_MONTHS: product_pricing.THREE_MONTHS.representative_interest,
    } as TRepresentativeInterest;
  }

  return {
    THREE_MONTHS: product_pricing.THREE_MONTHS.representative_interest,
    TWELVE_MONTHS: product_pricing.TWELVE_MONTHS.representative_interest,
  } as TRepresentativeInterest;
};

export const shouldRedirectToCheckout = ({
  paymentOption,
  payLinkAmount,
  formalOffer,
}: {
  paymentOption: TPricingOption | null;
  payLinkAmount: number;
  formalOffer?: FormalOffer;
}) => {
  if (!formalOffer?.duration || !formalOffer?.available_credit) return false;

  if (formalOffer.available_credit < payLinkAmount) return false;
  const duration = getDurationInMonths(formalOffer.duration);

  if (paymentOption === 'payLater3' && duration === 3) return true;
  if (paymentOption === 'payLater12' && duration === 12) return true;
  return false;
};
